import { defineMessages } from "react-intl";

const messages = defineMessages({
    modify: {
        id: "general.modify",
    },
});

export default messages;
